import { useEffect, useState } from 'react'

export function LoadingSplash() {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 1100)
    return () => clearTimeout(t)
  }, [])

  if (!visible) return null
  return (
    <div className="loading-splash" aria-hidden>
      <div className="loading-splash__brand">BNGU</div>
      <div className="loading-splash__bar">
        <div className="loading-splash__bar-fill" />
      </div>
      <div className="loading-splash__hint">正在准备视差与手势识别</div>
    </div>
  )
}
